import React from 'react';
import { imgUrl } from '../api/tmdb';
import { Plus, Check, Star } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { useDetail } from '../context/DetailContext';

const MovieCard = ({ item, variant = 'poster' }) => {
  const { open } = useDetail();
  const { isInList, toggleMyList } = useApp();
  const inList = isInList(item);
  const title = item.title || item.name;
  const isBackdrop = variant === 'backdrop';
  const img = isBackdrop
    ? imgUrl(item.backdrop_path || item.poster_path, 'w780')
    : imgUrl(item.poster_path || item.backdrop_path, 'w500');
  const year = (item.release_date || item.first_air_date || '').slice(0, 4);
  const progressPct = typeof item.progress === 'number' && item.progress > 0.01 && item.progress < 0.98
    ? Math.max(3, Math.round(item.progress * 100))
    : 0;

  return (
    <button
      onClick={() => open(item)}
      className={`tv-focusable relative flex-shrink-0 ${isBackdrop ? 'w-[340px] h-[190px]' : 'w-[200px] h-[300px]'} rounded-xl overflow-hidden bg-white/5 card-shine text-left`}
    >
      {img ? (
        <img src={img} alt={title} loading="lazy" className="w-full h-full object-cover" />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-white/40 text-sm">No image</div>
      )}

      {/* Bottom info gradient */}
      <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/90 via-black/40 to-transparent">
        <div className="flex items-center gap-2 text-[11px] text-white/80 mb-1">
          {item.vote_average ? (
            <span className="flex items-center gap-1"><Star size={11} className="text-amber-400 fill-amber-400" /> {item.vote_average.toFixed(1)}</span>
          ) : null}
          {year && <span>• {year}</span>}
        </div>
        <div className="text-[13px] font-semibold line-clamp-2 text-white">{title}</div>
      </div>

      {/* My list badge */}
      <span
        role="button"
        tabIndex={-1}
        onClick={(e) => { e.stopPropagation(); toggleMyList(item); }}
        className={`absolute top-2 right-2 w-8 h-8 rounded-full flex items-center justify-center backdrop-blur ${inList ? 'bg-[#E50914] text-white' : 'bg-black/60 text-white/80 hover:bg-black/80'}`}
      >
        {inList ? <Check size={16} /> : <Plus size={16} />}
      </span>

      {/* Progress bar (Continue Watching) */}
      {progressPct > 0 && (
        <div className="absolute left-0 right-0 bottom-0 h-1 bg-black/60">
          <div className="h-full bg-[#E50914]" style={{ width: `${progressPct}%` }} />
        </div>
      )}
    </button>
  );
};

export default MovieCard;
